import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";

const HERO_IMG = "https://customer-assets.emergentagent.com/job_yago-aesthetic/artifacts/cu6nx87a_fca62e6c-0e7e-49c3-b284-d552ffb4a060.jpg";

export const HeroSection = () => {
  const scrollToForm = () => {
    const el = document.querySelector("#contato");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-screen flex items-end overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src={HERO_IMG}
          alt="Dr. Yago Almeida em centro cirúrgico"
          className="w-full h-full object-cover object-[center_30%]"
        />
        <div className="absolute inset-0 bg-navy/55" />
        <div className="absolute inset-0 bg-gradient-to-t from-navy/90 via-navy/20 to-transparent" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-8 pb-24 md:pb-32 pt-32 w-full">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.3 }}
        >
          <h1
            className="font-heading text-white text-5xl sm:text-6xl lg:text-8xl font-medium leading-[1.05] max-w-3xl mb-4"
            data-testid="hero-name"
          >
            Dr. Yago Almeida
          </h1>

          <p
            className="font-body text-gold/90 text-xs md:text-sm font-medium tracking-[0.35em] uppercase mb-10"
            data-testid="hero-subtitle"
          >
            Cirurgia Plástica
          </p>

          <p className="font-body text-white/60 text-base md:text-lg font-light leading-[1.7] max-w-xl mb-14">
            Excelência técnica, planejamento individualizado e senso estético apurado para resultados harmônicos, refinados e elegantes.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <button
              onClick={scrollToForm}
              className="bg-gold text-white font-body font-semibold text-xs tracking-[0.15em] uppercase px-10 py-4 hover:bg-gold/85 transition-all duration-300"
              data-testid="hero-cta-button"
            >
              Agendar Consulta
            </button>
            <a
              href="#procedimentos"
              className="border border-white/20 text-white/80 font-body font-medium text-xs tracking-[0.15em] uppercase px-10 py-4 hover:bg-white/5 hover:border-white/30 transition-all duration-300 text-center"
              data-testid="hero-secondary-button"
            >
              Procedimentos
            </a>
          </div>
        </motion.div>

        <motion.div
          className="absolute bottom-10 left-1/2 -translate-x-1/2"
          animate={{ y: [0, 6, 0] }}
          transition={{ repeat: Infinity, duration: 2.5 }}
        >
          <ChevronDown className="text-white/25" size={24} />
        </motion.div>
      </div>
    </section>
  );
};
